import { Box, BoxProps, ColorOptions, LoaderNew, ModBox, Spacer, TextNew, TextNewProps } from '@jfs/ui-new'

export const FallbackScreen = () => {
  return (
    <Box {...style.mainViewWrap}>
      <ModBox w={'100%'} height={'100%'} justify={'center'}>
        <LoaderNew color="PRIMARY" />
        <Spacer size={16} />
        <TextNew {...style.loadingText} color={'PRIMARY'} title={'Loading'} />
      </ModBox>
    </Box>
  )
}

const style = {
  mainViewWrap: {
    f: 1,
    h: '100vh',
    backgroundColor: 'WHITE' as ColorOptions,
    justify: 'center',
    flexDirection: 'row',
  } as BoxProps,
  menuView: {
    zIndex: 2,
    height: '100%',
    backgroundColor: '#214796' as ColorOptions,
    overflow: 'auto',
    w: 224,
  } as BoxProps,
  loadingText: {
    type: 'bodyMedium14',
    textAlign: 'center',
    color: 'PRIMARY',
  } as TextNewProps,
}
